export default [
  { type: 'FACEBOOK', url: 'https://www.facebook.com/weintour' },
  { type: 'TWITTER', url: 'https://twitter.com/weininstitut' },
  { type: 'INSTAGRAM', url: 'https://www.instagram.com/wines_of_germany' },
  { type: 'YOUTUBE', url: 'https://www.youtube.com/user/deutscheweine' },
];
